/* ALERT */
export const ALERT_SET = 'ALERT_SET';
export const ALERT_DIALOG_CLOSE = 'ALERT_DIALOG_CLOSE';
export const ALERTS_CLEAR = 'ALERT_CLEAR';

/* MAP */
export const MAP_NEW = 'MAP_NEW';
export const MAP_SET = 'MAP_SET';
export const MAP_NAME_SET = 'MAP_NAME_SET';
export const MAP_CONTEXT_MENU_OPEN = 'MAP_CONTEXT_MENU_OPEN';
export const MAP_CONTEXT_MENU_CLOSE = 'MAP_CONTEXT_MENU_CLOSE';
export const MAP_COORDINATE_OPEN = 'MAP_COORDINATE_OPEN';
export const MAP_COORDINATE_CLOSE = 'MAP_COORDINATE_CLOSE';
export const MAP_EARTH_ENGINE_VALUE_SHOW = 'MAP_EARTH_ENGINE_VALUE_SHOW';

/* BASEMAP */
export const BASEMAP_ADD = 'BASEMAP_ADD';
export const BASEMAP_REMOVE = 'BASEMAP_REMOVE';
export const BASEMAP_SELECTED = 'BASEMAP_SELECTED';
export const BASEMAP_TOGGLE_EXPAND = 'BASEMAP_TOGGLE_EXPAND';
export const BASEMAP_TOGGLE_VISIBILITY = 'BASEMAP_TOGGLE_VISIBILITY';
export const BASEMAP_CHANGE_OPACITY = 'BASEMAP_CHANGE_OPACITY';

/* LAYER */
export const LAYER_ADD = 'LAYER_ADD';
export const LAYER_REMOVE = 'LAYER_REMOVE';
export const LAYER_CHANGE_OPACITY = 'LAYER_CHANGE_OPACITY';
export const LAYER_EDIT = 'LAYER_EDIT';
export const LAYER_EDIT_SUCCESS = 'LAYER_EDIT_SUCCESS';
export const LAYER_EDIT_ERROR = 'LAYER_EDIT_ERROR';
export const LAYER_CANCEL = 'LAYER_CANCEL';
// export const LAYER_GET = 'LAYER_GET';
export const LAYER_LOAD = 'LAYER_LOAD';
export const LAYER_LOAD_SUCCESS = 'LAYER_LOAD_SUCCESS';
export const LAYER_LOAD_ERROR = 'LAYER_LOAD_ERROR';
export const LAYER_SORT = 'LAYER_SORT';
export const LAYER_TOGGLE_EXPAND = 'LAYER_TOGGLE_EXPAND';
export const LAYER_TOGGLE_VISIBILITY = 'LAYER_TOGGLE_VISIBILITY';
export const LAYER_UPDATE = 'LAYER_UPDATE';
export const LAYER_DRILL = 'LAYER_DRILL';
export const LAYERS_DIALOG_OPEN = 'LAYERS_DIALOG_OPEN';
export const LAYERS_DIALOG_CLOSE = 'LAYERS_DIALOG_CLOSE';

/* EXTERNAL LAYERS */
export const EXTERNAL_LAYERS_LOAD = 'EXTERNAL_LAYERS_LOAD';
export const EXTERNAL_LAYERS_LOAD_ERROR = 'EXTERNAL_LAYERS_LOAD_ERROR';
export const EXTERNAL_LAYER_ADD = 'EXTERNAL_LAYER_ADD';
export const EXTERNAL_LAYER_REMOVE = 'EXTERNAL_LAYER_REMOVE';

/* FAVORITE */
export const FAVORITE_LOAD = 'FAVORITE_LOAD';
export const FAVORITE_LOAD_SUCCESS = 'FAVORITE_LOAD_SUCCESS';
export const FAVORITE_LOAD_ERROR = 'FAVORITE_LOAD_ERROR';
export const FAVORITE_SAVE = 'FAVORITE_SAVE';
export const FAVORITE_SAVE_NEW = 'FAVORITE_SAVE_NEW';
export const FAVORITE_SAVE_NEW_SUCCESS = 'FAVORITE_SAVE_NEW_SUCCESS';
export const FAVORITE_SAVE_NEW_ERROR = 'FAVORITE_SAVE_NEW_ERROR';
export const FAVORITE_SAVE_NEW_DIALOG_OPEN = 'FAVORITE_SAVE_NEW_DIALOG_OPEN';
export const FAVORITE_SAVE_NEW_DIALOG_CLOSE = 'FAVORITE_SAVE_NEW_DIALOG_CLOSE';
export const FAVORITE_INTERPRETATION_SAVE = 'FAVORITE_INTERPRETATION_SAVE';
export const FAVORITES_DIALOG_OPEN = 'FAVORITES_DIALOG_OPEN';
export const FAVORITES_DIALOG_CLOSE = 'FAVORITES_DIALOG_CLOSE';

/* DATA TABLE */
export const DATA_TABLE_OPEN = 'DATA_TABLE_OPEN';
export const DATA_TABLE_CLOSE = 'DATA_TABLE_CLOSE';
export const DATA_TABLE_TOGGLE = 'DATA_TABLE_TOGGLE';
export const DATA_TABLE_RESIZE = 'DATA_TABLE_RESIZE';

/* DATA FILTER */
export const DATA_FILTER_SET = 'DATA_FILTER_SET';
export const DATA_FILTER_CLEAR = 'DATA_FILTER_CLEAR';

/* ORGANISATION UNITS */
export const ORGANISATION_UNIT_LOAD = 'ORGANISATION_UNIT_LOAD';
export const ORGANISATION_UNIT_SET = 'ORGANISATION_UNIT_SET';
export const ORGANISATION_UNIT_CLOSE = 'ORGANISATION_UNIT_CLOSE';
export const ORGANISATION_UNIT_SELECT = 'ORGANISATION_UNIT_SELECT';
export const ORGANISATION_UNIT_UNSELECT = 'ORGANISATION_UNIT_UNSELECT';
export const ORGANISATION_UNIT_RELOCATE_START =
    'ORGANISATION_UNIT_RELOCATE_START';
export const ORGANISATION_UNIT_RELOCATE_STOP =
    'ORGANISATION_UNIT_RELOCATE_STOP';
export const ORGANISATION_UNIT_COORDINATE_CHANGE =
    'ORGANISATION_UNIT_COORDINATE_CHANGE';
export const ORGANISATION_UNIT_COORDINATE_CHANGE_ERROR =
    'ORGANISATION_UNIT_COORDINATE_CHANGE_ERROR';
export const ORGANISATION_UNIT_COORDINATE_SET =
    'ORGANISATION_UNIT_COORDINATE_SET';
export const ORGANISATION_UNIT_TREE_LOAD = 'ORGANISATION_UNIT_TREE_LOAD';
export const ORGANISATION_UNIT_TREE_LOAD_ERROR =
    'ORGANISATION_UNIT_TREE_LOAD_ERROR';
export const ORGANISATION_UNIT_TREE_SET = 'ORGANISATION_UNIT_TREE_SET';
export const ORGANISATION_UNIT_GROUPS_LOAD = 'ORGANISATION_UNIT_GROUPS_LOAD';
export const ORGANISATION_UNIT_GROUPS_LOAD_ERROR =
    'ORGANISATION_UNIT_GROUPS_LOAD_ERROR';
export const ORGANISATION_UNIT_GROUPS_SET = 'ORGANISATION_UNIT_GROUPS_SET';
export const ORGANISATION_UNIT_GROUP_SETS_LOAD =
    'ORGANISATION_UNIT_GROUP_SETS_LOAD';
export const ORGANISATION_UNIT_GROUP_SETS_LOAD_ERROR =
    'ORGANISATION_UNIT_GROUP_SETS_LOAD_ERROR';
export const ORGANISATION_UNIT_GROUP_SETS_SET =
    'ORGANISATION_UNIT_GROUP_SETS_SET';
export const ORGANISATION_UNIT_LEVELS_SET = 'ORGANISATION_UNIT_LEVELS_SET';
export const ORGANISATION_UNIT_LEVELS_LOAD = 'ORGANISATION_UNIT_LEVELS_LOAD';
export const ORGANISATION_UNIT_LEVELS_LOAD_ERROR =
    'ORGANISATION_UNIT_LEVELS_LOAD_ERROR';

/* ABOUT DIALOG */
export const ABOUT_DIALOG_OPEN = 'ABOUT_DIALOG_OPEN';
export const ABOUT_DIALOG_CLOSE = 'ABOUT_DIALOG_CLOSE';

/* USER INTERFACE */
export const SCREEN_RESIZE = 'SCREEN_RESIZE';
export const LAYERS_PANEL_OPEN = 'LAYERS_PANEL_OPEN';
export const LAYERS_PANEL_CLOSE = 'LAYERS_PANEL_CLOSE';

/* LOADING */
export const LOADING = 'LOADING';
export const LOADED = 'LOADED';

/* SYSTEM SETTINGS */
export const SYSTEM_DATA_SET = 'SYSTEM_DATA_SET';

/* USER */
export const USER_SET = 'USER_SET';

/* PROGRAMS */
export const PROGRAMS_LOAD = 'PROGRAMS_LOAD';
export const PROGRAMS_LOAD_ERROR = 'PROGRAMS_LOAD_ERROR';
export const PROGRAMS_SET = 'PROGRAMS_SET';
export const PROGRAM_STAGES_LOAD = 'PROGRAM_STAGES_LOAD';
export const PROGRAM_STAGES_LOAD_ERROR = 'PROGRAM_STAGES_LOAD_ERROR';
export const PROGRAM_STAGES_SET = 'PROGRAM_STAGES_SET';
export const PROGRAM_ATTRIBUTES_LOAD = 'PROGRAM_ATTRIBUTES_LOAD';
export const PROGRAM_ATTRIBUTES_LOAD_ERROR = 'PROGRAM_ATTRIBUTES_LOAD_ERROR';
export const PROGRAM_ATTRIBUTES_SET = 'PROGRAM_ATTRIBUTES_SET';
export const PROGRAM_DATA_ELEMENTS_LOAD = 'PROGRAM_DATA_ELEMENTS_LOAD';
export const PROGRAM_DATA_ELEMENTS_LOAD_ERROR =
    'PROGRAM_DATA_ELEMENTS_LOAD_ERROR';
export const PROGRAM_DATA_ELEMENTS_SET = 'PROGRAM_DATA_ELEMENTS_SET';
export const PROGRAM_INDICATORS_LOAD = 'PROGRAM_INDICATORS_LOAD';
export const PROGRAM_INDICATORS_LOAD_ERROR = 'PROGRAM_INDICATORS_LOAD_ERROR';
export const PROGRAM_INDICATORS_SET = 'PROGRAM_INDICATORS_SET ';
export const PROGRAM_STAGE_DATA_ELEMENTS_LOAD =
    'PROGRAM_STAGE_DATA_ELEMENTS_LOAD';
export const PROGRAM_STAGE_DATA_ELEMENTS_LOAD_ERROR =
    'PROGRAM_STAGE_DATA_ELEMENTS_LOAD_ERROR';
export const PROGRAM_STAGE_DATA_ELEMENTS_SET =
    'PROGRAM_STAGE_DATA_ELEMENTS_SET';

/* OPTION SETS */
export const OPTION_SET_LOAD = 'OPTION_SET_LOAD';
export const OPTION_SET_LOAD_ERROR = 'OPTION_SET_LOAD_ERROR';
export const OPTION_SET_ADD = 'OPTION_SET_ADD';

/* LAYER EDIT */
export const LAYER_EDIT_PROGRAM_SET = 'LAYER_EDIT_PROGRAM_SET';
export const LAYER_EDIT_PROGRAM_STAGE_SET = 'LAYER_EDIT_PROGRAM_STAGE_SET';
export const LAYER_EDIT_PROGRAM_INDICATOR_SET =
    'LAYER_EDIT_PROGRAM_INDICATOR_SET';
export const LAYER_EDIT_PERIOD_SET = 'LAYER_EDIT_PERIOD_SET';
export const LAYER_EDIT_START_DATE_SET = 'LAYER_EDIT_START_DATE_SET';
export const LAYER_EDIT_END_DATE_SET = 'LAYER_EDIT_END_DATE_SET';
export const LAYER_EDIT_FILTER_ADD = 'LAYER_EDIT_FILTER_ADD';
export const LAYER_EDIT_FILTER_REMOVE = 'LAYER_EDIT_FILTER_REMOVE';
export const LAYER_EDIT_FILTER_CHANGE = 'LAYER_EDIT_FILTER_CHANGE';
export const LAYER_EDIT_STYLE_DATA_ITEM_SET = 'LAYER_EDIT_STYLE_DATA_ITEM_SET';
export const LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET =
    'LAYER_EDIT_STYLE_DATA_ITEM_OPTIONS_SET';
export const LAYER_EDIT_CLASSIFICATION_SET = 'LAYER_EDIT_CLASSIFICATION_SET';
export const LAYER_EDIT_COLOR_SCALE_SET = 'LAYER_EDIT_COLOR_SCALE_SET';
export const LAYER_EDIT_DATA_ITEM_SET = 'LAYER_EDIT_DATA_ITEM_SET';
export const LAYER_EDIT_EVENT_COORDINATE_FIELD_SET =
    'LAYER_EDIT_EVENT_COORDINATE_FIELD_SET';
export const LAYER_EDIT_EVENT_CLUSTERING_SET =
    'LAYER_EDIT_EVENT_CLUSTERING_SET';
export const LAYER_EDIT_EVENT_POINT_RADIUS_SET =
    'LAYER_EDIT_EVENT_POINT_RADIUS_SET';
export const LAYER_EDIT_EVENT_POINT_COLOR_SET =
    'LAYER_EDIT_EVENT_POINT_COLOR_SET';
export const LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET =
    'LAYER_EDIT_ORGANISATION_UNIT_LEVELS_SET';
export const LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET =
    'LAYER_EDIT_ORGANISATION_UNIT_GROUPS_SET'; // Org units selection
export const LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET =
    'LAYER_EDIT_ORGANISATION_UNIT_GROUP_SET'; // Facility TODO: Distinguish frome above
export const LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE =
    'LAYER_EDIT_ORGANISATIOM_UNIT_TOGGLE';
export const LAYER_EDIT_USER_ORGANISATION_UNITS_SET =
    'LAYER_EDIT_USER_ORGANISATION_UNITS_SET';
export const LAYER_EDIT_VALUE_TYPE_SET = 'LAYER_EDIT_VALUE_TYPE_SET';
export const LAYER_EDIT_INDICATOR_GROUP_SET = 'LAYER_EDIT_INDICATOR_GROUP_SET';
export const LAYER_EDIT_PERIOD_TYPE_SET = 'LAYER_EDIT_PERIOD_TYPE_SET';
export const LAYER_EDIT_AGGREGATION_TYPE_SET =
    'LAYER_EDIT_AGGREGATION_TYPE_SET';
export const LAYER_EDIT_DATA_ELEMENT_GROUP_SET =
    'LAYER_EDIT_DATA_ELEMENT_GROUP_SET';
export const LAYER_EDIT_PARAMS_SET = 'LAYER_EDIT_PARAMS_SET';
export const LAYER_EDIT_FILTER_SET = 'LAYER_EDIT_FILTER_SET';
export const LAYER_EDIT_LABELS_SET = 'LAYER_EDIT_LABELS_SET';
export const LAYER_EDIT_LABEL_FONT_SIZE_SET = 'LAYER_EDIT_LABEL_FONT_SIZE_SET';
export const LAYER_EDIT_LABEL_FONT_WEIGHT_SET =
    'LAYER_EDIT_LABEL_FONT_WEIGHT_SET';
export const LAYER_EDIT_LABEL_FONT_STYLE_SET =
    'LAYER_EDIT_LABEL_FONT_STYLE_SET';
export const LAYER_EDIT_LABEL_FONT_COLOR_SET =
    'LAYER_EDIT_LABEL_FONT_COLOR_SET';
export const LAYER_EDIT_AREA_RADIUS_SET = 'LAYER_EDIT_AREA_RADIUS_SET';
export const LAYER_EDIT_RADIUS_LOW_SET = 'LAYER_EDIT_RADIUS_LOW_SET';
export const LAYER_EDIT_RADIUS_HIGH_SET = 'LAYER_EDIT_RADIUS_HIGH_SET';
export const LAYER_EDIT_LEGEND_SET_SET = 'LAYER_EDIT_LEGEND_SET_SET';
export const LAYER_EDIT_ORGANISATION_UNIT_PATH_SET =
    'LAYER_EDIT_ORGANISATION_UNIT_PATH_SET'; // Load organisation unit tree path (temporary solution, as favorites don't include paths)
export const LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD =
    'LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD'; // Load organisation unit tree path (temporary solution, as favorites don't include paths)
export const LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD_ERROR =
    'LAYER_EDIT_ORGANISATION_UNIT_PATH_LOAD_ERROR'; // Load organisation unit tree path (temporary solution, as favorites don't include paths)
export const LAYER_EDIT_OPERAND_SET = 'OPERAND_SET'; // Data element operands (details)

/* PERIODS */
export const RELATIVE_PERIODS_SET = 'RELATIVE_PERIODS_SET';
export const RELATIVE_PERIODS_TRANSLATE = 'RELATIVE_PERIODS_TRANSLATE';

/* INDICATORS */
export const INDICATORS_SET = 'INDICATORS_SET';
export const INDICATORS_LOAD = 'INDICATORS_LOAD';
export const INDICATORS_LOAD_ERROR = 'INDICATORS_LOAD_ERROR';
export const INDICATOR_GROUPS_LOAD = 'INDICATOR_GROUPS_LOAD';
export const INDICATOR_GROUPS_LOAD_ERROR = 'INDICATOR_GROUPS_LOAD_ERROR';
export const INDICATOR_GROUPS_SET = 'INDICATOR_GROUPS_SET';

/* DATA ELEMENTS */
export const DATA_ELEMENT_GROUPS_SET = 'DATA_ELEMENT_GROUPS_SET';
export const DATA_ELEMENT_GROUPS_LOAD = 'DATA_ELEMENT_GROUPS_LOAD';
export const DATA_ELEMENT_GROUPS_LOAD_ERROR = 'DATA_ELEMENT_GROUPS_LOAD_ERROR';
export const DATA_ELEMENTS_SET = 'DATA_ELEMENTS_SET';
export const DATA_ELEMENTS_LOAD = 'DATA_ELEMENTS_LOAD';
export const DATA_ELEMENTS_LOAD_ERROR = 'DATA_ELEMENTS_LOAD_ERROR';
export const DATA_ELEMENT_OPERANDS_SET = 'DATA_ELEMENT_OPERANDS_SET';
export const DATA_ELEMENT_OPERANDS_LOAD = 'DATA_ELEMENT_OPERANDS_LOAD';
export const DATA_ELEMENT_OPERANDS_LOAD_ERROR =
    'DATA_ELEMENT_OPERANDS_LOAD_ERROR';

/* DATA SETS */
export const DATA_SETS_SET = 'DATA_SETS_SET';
export const DATA_SETS_LOAD = 'DATA_SETS_LOAD';
export const DATA_SETS_LOAD_ERROR = 'DATA_SETS_LOAD_ERROR';

/* LEGEND SETS */
export const LEGEND_SETS_SET = 'LEGEND_SETS_SET';
export const LEGEND_SETS_LOAD = 'LEGEND_SETS_LOAD';
export const LEGEND_SETS_LOAD_ERROR = 'LEGEND_SETS_LOAD_ERROR';

/* EARTH ENGINE */
export const EARTH_ENGINE_COLLECTION_LOAD = 'EARTH_ENGINE_COLLECTION_LOAD';
export const EARTH_ENGINE_COLLECTION_LOAD_ERROR =
    'EARTH_ENGINE_COLLECTION_LOAD_ERROR';
export const EARTH_ENGINE_COLLECTION_SET = 'EARTH_ENGINE_COLLECTION_SET';

/* USER */
export const USER_SETTINGS_SET = 'USER_SETTINGS_SET';

/* MESSAGE (SNACKBAR) */
export const MESSAGE_SET = 'MESSAGE_SET';
export const MESSAGE_CLEAR = 'MESSAGE_CLEAR';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js